import React, { useState, useEffect } from 'react'; 
import Headerone from '../headerone/newMain' 
import ScriptLoader from '../mencontact/scriptLoader'; 

function InternationalConference() {
 


  return (
    <>
      <ScriptLoader />
      <Headerone />
        {/* <div className='conferencebanner'>
            <img src='assets/img/chancellor-new_banner.jpg' />
        </div> */}
       <div className='conference'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-12'>
                    <iframe src="https://flowpaper.com/flipbook/https://www.mvn.edu.in/assets/img/new4th-International-Conference-A4.pdf" width="70%" height="800" allowFullScreen>
</iframe>
                </div>
            </div>
        </div>
       </div>

    </>
  )
}

export default InternationalConference

 